module.exports = __webpack_public_path__ + "img/lancia.d6e1be12.svg";